enum SubscriptionAction {
  adjust = 1,
  change = 2,
}

export default SubscriptionAction;
